import React from 'react';
import { BrowserRouter as Router, useLocation, useRoutes } from 'react-router-dom';
import { routes } from '../../routes';
import ErrorBoundary from '../molecules/ErrorBoundary';
import { ManifestHandler } from '../ManifestHandler';
import TenantMetadata from '../domain/TenantMetadata';

/**
 * Router component that handles all route rendering
 * Separated from App component for better organization
 */
const AppRouter: React.FC = () => {
  const routeElements = useRoutes(routes);
  return <>{routeElements}</>;
};

export function usesCXClientShell(pathname: string) {
  const pathSegments = pathname.split('/').filter(Boolean);
  const publicCXSurveyPath =
    pathSegments.length === 1 && !/^\d+$/.test(pathSegments[0]);

  return (
    pathname === '/' ||
    pathname === '/ratings' ||
    pathname === '/dashboard' ||
    pathname.startsWith('/preview/') ||
    publicCXSurveyPath
  );
}

/**
 * Layout wrapper component
 * Handles common layout elements like navigation, error boundaries, etc.
 */
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const usesCxShell = usesCXClientShell(pathname);

  return (
    <div className={usesCxShell ? 'theme-cx-client' : 'theme-dark'}>
      <ManifestHandler />
      <TenantMetadata />
      <div className={usesCxShell ? 'cx-client-container' : 'review-container'}>
        {/* <NavigationBar /> */}
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      </div>
    </div>
  );
};

/**
 * Main router provider component
 * Wraps the app with Router and provides routing context
 */
const RouterProvider: React.FC = () => {
  return (
    <Router>
      <Layout>
        <AppRouter />
      </Layout>
    </Router>
  );
};

export default RouterProvider;
